import { Button } from '@quicktools/shared-components';

import { ReactComponent as RightArrow } from '../../../../svgIcons/right-arrow.svg';

import useStyles from './styles';
import { ICardButton } from './types';

function CardButtons({ handleArrowClick, handleFindMoreClick }: ICardButton) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {handleFindMoreClick && (
        <Button variant="icon" className={classes.findMoreButton} onClick={handleFindMoreClick}>
          Find out more
        </Button>
      )}
      <Button variant="icon" className={classes.arrowButton} onClick={handleArrowClick}>
        <RightArrow />
      </Button>
    </div>
  );
}
export default CardButtons;
